import { useMissedTasksAlertData } from "@/queries/queries/homepageQueries"
import { useStore } from "@/zustand/store"
import { useTranslation } from "react-i18next"
import { IoMdCloseCircleOutline } from "react-icons/io"
import { IoWarning } from "react-icons/io5"

export default function MissedTasksAlert() {
  const show = useStore((store) => store.missedTasksAlertShow)
  const setShow = useStore((store) => store.setMissedTasksAlertShow)

  const missedTasksAlertQuery = useMissedTasksAlertData()

  const { t } = useTranslation()

  if (
    !show ||
    missedTasksAlertQuery.isLoading ||
    !missedTasksAlertQuery.data?.has_missed_tasks_alert
  )
    return null

  return (
    <div
      className="d-flex align-items-center gap-4 p-4 position-relative"
      style={{
        background: "linear-gradient(135deg, #fffbeb 0%, #fff 100%)",
        border: "1px solid #fef3c7",
        borderRadius: "20px",
        boxShadow: "0 4px 15px rgba(245, 158, 11, 0.05)",
      }}
    >
      <div
        className="rounded-circle d-flex align-items-center justify-content-center bg-warning-subtle"
        style={{ width: "60px", height: "60px", flexShrink: 0 }}
      >
        <IoWarning size={32} className="text-warning" />
      </div>
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h5 className="m-0 fw-bold text-warning d-flex align-items-center gap-2">
            {t("homePage.missedTasksAlert.title")}
          </h5>
          <div
            onClick={() => setShow(false)}
            style={{ cursor: "pointer" }}
            className="text-muted hover-opacity"
          >
            <IoMdCloseCircleOutline size={24} />
          </div>
        </div>
        <p
          className="text-muted m-0"
          style={{ fontSize: "1rem", lineHeight: "1.5" }}
        >
          {t("homePage.missedTasksAlert.message")}
        </p>
      </div>
    </div>
  )
}
